import { Link } from 'react-router-dom'
import { Tooltip } from '@/shared/components/Tooltip'
import { ShieldIcon } from '@/shared/components/Icons'
import { useIsPlatformOperator } from '@/auth/platformRole'

/**
 * Entry point to the platform operator console. Shown only when the signed-in token carries the
 * `platform-operator` role (auth/platformRole.ts) - display only; the worker re-checks role, client
 * and the operator allowlist on every /api/platform call, and the console's own guard explains a
 * role that the worker does not admit.
 */
export function AdminButton() {
  const isOperator = useIsPlatformOperator()
  if (!isOperator) return null
  return (
    <Tooltip text="Platform admin console" placement="bottom">
      <Link to="/admin" className="btn btn-sm" aria-label="Platform admin console">
        <ShieldIcon size={13} /> Admin
      </Link>
    </Tooltip>
  )
}

